import {createContext, useContext} from "react";

export interface Status {
    dataType: boolean;
    destination: boolean;
    done: boolean;
}

export interface Options {
    selectedDataType: string | null;
    selectedDestination: string  | null;
}

interface UploadContextType {
    status: Status
    options: Options;
    setStatus: (status: Status) => void;
    setOptions: (options: Options) => void;
}

export const UploadContext = createContext<UploadContextType>(
    {} as UploadContextType
);

export const useUpload = () => {
    return useContext(UploadContext)
}
